import { withInstall } from '@ll-plus/utils'

import IconPicker from './src/icon-picker.vue'

export const LlIconPicker = withInstall(IconPicker)
export default LlIconPicker
export * from './src/config'

// 把ZIcon组件类型合并带全局组件中 到时候使用时有提示
declare module 'vue' {
  export interface GlobalComponents {
    LlIconPicker: typeof IconPicker
  }
}
